import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { isArray } from 'lodash';
import { Input, Checkbox } from '~/components/Form';
import { t, number } from '~/helpers';

import api from '~/services/api';
import { ContainerForm } from './styles';
import { Spinner } from '~/components';

import { ConfirmationDialogRaw } from '~/components';

export default function MyForm({ data, reference, close, cancelarAcao }) {

  useEffect(() => {
    reference.current.setData(data);
  }, [data]);

  const [isLoading, setIsLoading] = useState(false);

  //ConfirmationDialogRaw o registro do geral
  const [tituloConfirmationDialogRaw, setTituloConfirmationDialogRaw] = React.useState('Abastecimento');
  const [mensagemConfirmationDialogRaw, setMensagemConfirmationDialogRaw] = React.useState('Deseja confirmar a operação?');
  const [openConfirmationDialogRaw, setOpenConfirmationDialogRaw] = React.useState(false);
  const [valueConfirmationDialogRaw, setValueConfirmationDialogRaw] = React.useState("CLICK-OK");
  const [paramSubmit, setParamSubmit] = React.useState();

  const execHandleConfirmar = (param) => {

    setParamSubmit(param);
    //customizando a mensagem 
    //param.chkAlterarHodVeiculo === true ? 1 : 0
    if (param.chkAlterarHodVeiculo === true) {
      setMensagemConfirmationDialogRaw(`Será realizado a alteração do hodômetro do abastecimento e do KM base do veículo Placa: ${data.veic_placa_aux} com o Hodômetro novo: ${number(param.movi_totalizador_veiculo_novo,1)}. Os dados estão corretos?`);
    } else {
      setMensagemConfirmationDialogRaw(`Será realizado a alteração do hodômetro do abastecimento do veículo Placa: ${data.veic_placa_aux} com o Hodômetro novo: ${number(param.movi_totalizador_veiculo_novo,1)}. Os dados estão corretos?" ,`);
    }
    setOpenConfirmationDialogRaw(true);
  };

  const handleConfirmationDialogRaw = (newValue) => {
    //console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (newValue) {
      setValueConfirmationDialogRaw(newValue);
      setIsLoading(false);
      if (newValue === 'CLICK-OK') {
        //handleSubmitConfirmar();
        setIsLoading(true);
        handleSubmit(paramSubmit)
      }
    } else {
      cancelarAcao();
      setIsLoading(false);
    }

  };

  async function handleSubmitPegunta(param) {

    try {

      const schema = Yup.object().shape({
        // movi_totalizador_veiculo_novo: Yup.number()
        //   .required(t('s.geral.validacao.campoobrigatorio'))          
        //   .min(0),
        movi_totalizador_veiculo_novo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .positive('Deve ser maior que 0')
          .min(0, t('s.geral.validacao.tamanhominimo').replace('%s', 0))
          .max(9999999, t('s.geral.validacao.tamanhomaximo').replace('%s', 7))
          .test(
            "maxDigitsAfterDecimal",
            "Valor informado inválido! Exemplo de valor válido 999999,9! ",
            (number) => /^\d+(\.\d{1,1})?$/.test(number)
          )


        // .test(
        //   'is-decimal',
        //   'invalid decimal',
        //   value => (value + "").match(/^\d*\.{1}\d*$/),
        // ),


      });


      await schema.validate(param, {
        abortEarly: false,
      });

      await setIsLoading(true);
      await execHandleConfirmar(param);

    } catch (err) {
      await setIsLoading(false);
      await cancelarAcao();
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }

  }




  async function handleSubmit(param) {
    try {

      const schema = Yup.object().shape({
        // movi_totalizador_veiculo_novo: Yup.number()
        //   .required(t('s.geral.validacao.campoobrigatorio'))          
        //   .min(0),
        movi_totalizador_veiculo_novo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .positive('Deve ser maior que 0')
          .min(0, t('s.geral.validacao.tamanhominimo').replace('%s', 0))
          .max(9999999, t('s.geral.validacao.tamanhomaximo').replace('%s', 7))
          .test(
            "maxDigitsAfterDecimal",
            "Valor informado inválido! Exemplo de valor válido 999999,9! ",
            (number) => /^\d+(\.\d{1,1})?$/.test(number)
          )
      });
      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        movi_codigo: data.movi_codigo,
        orga_codigo: data.orga_codigo,
        unid_codigo: data.unid_codigo,
        veic_placa: data.veic_placa,
        enviarSEPLAG: (param.chkEnviaSeplag === true ? 1 : 0),
        atualizaTotalizadorVeiculo: (param.chkAlterarHodVeiculo === true ? 1 : 0),
        virouTotalizador: (param.chkViradaHodometro === true ? 1 : 0),
        totalizadorAnterior: data.movi_totalizador_veic_anterior,
        totalizadorAtual: data.movi_totalizador_veiculo,
        totalizadorNovo: Number(param.movi_totalizador_veiculo_novo),
      };

      try {
        await api.put('alterartotalizadorabastecimento', objSend);
        toast.success(t('s.geral.sucessoalteracao'));
        await setIsLoading(false);
        await close();
      } catch (err) {
        await cancelarAcao();
        await setIsLoading(false);
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      }
      //await setIsLoading(false);
      //await close();

    } catch (err) {
      await setIsLoading(false);
      await cancelarAcao();
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }
  return (
    <>
      <> {/* <> Para confirmação do form */}
        <ConfirmationDialogRaw
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Sim"
          textoBtnCancel="Não"
        />
      </> {/* <> Para confirmação do form */}

      {/* {isLoading ? (
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div>
      ) : (
          ''
      )} */}


      {/* <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmit}> */}
      {isLoading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (

        <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmitPegunta}>
          <Input
            name="veic_placa_aux"
            label='Placa'
            disabled
          />

          <Input
            disabled
            name="movi_totalizador_veiculo"
            label='Hodômetro Atual:'
            type="number"


          />

          <Input
            name="movi_totalizador_veiculo_novo"
            label='Informe o novo Hodômetro:'
            type="number"
          />

          <Checkbox
            name="chkEnviaSeplag"
            label='Informe se o registro deverá ser retransmitido para a SEPLAG:'
          />

          <Checkbox
            name="chkViradaHodometro"
            label='Informe se ocorreu virada de Hodometro:'
          />

          <Checkbox
            name="chkAlterarHodVeiculo"
            label='Informe se o hodômetro base do Veículo será alterado:'
          />
        </ContainerForm>


      )}
    </>)

}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
